import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { userQueries } from '@/lib/queries/user';

export const Route = createFileRoute('/_root/admin')({
  component: RouteComponent,
  beforeLoad: ({ context: { formatMessage } }) => ({
    title: formatMessage({ id: 'global.breadcrumb.admin' }),
  }),
  loader: async ({ context: { queryClient } }) => {
    const { superuser } = await queryClient.ensureQueryData(
      userQueries.current(),
    );

    if (!superuser) {
      throw redirect({ to: '/' });
    }
  },
});

function RouteComponent() {
  return <Outlet />;
}
